import { React, Fragment, memo, useEffect, useState } from 'react'
import { HeadingText, Avatar, Button } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { fptiCustomImpression } from '../../../utils'
import { VENMO_RESUBMIT } from '../../../constants/constants'

const LinkExpired = memo((props) => {
  const [impressionDone, setImpressionDone] = useState(false)

  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomImpression(props.fpti.PASSWORD_EXPIRED)
    }
  }, [])

  const handleSubmitBtn = (event) => {
    event.preventDefault()
    location.href = VENMO_RESUBMIT
  }

  return (
    <Fragment>
      <div className="flex-center">
        <Avatar
          src="https://www.paypalobjects.com/paypal-ui/illustrations/focused/svg/empty-critical.svg"
          className="focusedimg"
          alt="expired"
        />
      </div>

      <HeadingText size="sm">
        <Message id="closedAccountPages.linkexpired.lable_2" />
      </HeadingText>

      <div className="text-center requestForm-row">
        <Button id="submitbtn" onClick={handleSubmitBtn} size="sm">
          <Message id="closedAccountPages.submitnew_request.btn" />
        </Button>
      </div>
    </Fragment>
  )
})

LinkExpired.displayName = 'LinkExpired'
export default LinkExpired
